import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import BlogSubscribeBoxForm from "./BlogSubscribeBoxForm";
import type { BlogSubscribeBoxFormProps } from "./BlogSubscribeBoxForm";

const { Flex, Heading, Text, Divider } = Chakra;

const BlogSubscribeBox = ({ mobileView = false }: BlogSubscribeBoxFormProps) => {
  const translations = useTranslations();
  return (
    <Flex
      w="full"
      rounded="xl"
      direction="column"
      alignItems={mobileView ? "flex-start" : { base: "flex-start", md: "center" }}
      p={8}
      pos="relative"
      color="white"
      background="primary.800"
    >
      <Heading color="inherit" variant="h3" as="h3" pb={2}>
        {translations("join_the_community")}
      </Heading>
      <Text color="inherit" textAlign={mobileView ? "left" : { base: "left", md: "center" }} mb={6}>
        {translations("pick_up_tips")}
      </Text>
      <Divider
        display={mobileView ? "block" : { base: "block", md: "none" }}
        borderColor="greyscale.500"
        mx={-8}
        px={8}
        mb={6}
      />
      <BlogSubscribeBoxForm mobileView={mobileView} />
    </Flex>
  );
};

export default BlogSubscribeBox;
